module.exports = __webpack_public_path__ + "img/header-weddingRingsClassic.07ec3fa.webp";